import React, { useContext } from "react";
import { Button } from "primereact/button";
import LanguageContext from "../../components/Language/LanguageContext";


const Features = () => {
  const { language, messages, changeLanguage } = useContext(LanguageContext);
  return (
    <>
      <div
        style={{
          backgroundImage: "url('/images/Benefit/contact-1.png')",
          backgroundColor: "whitesmoke",
        }}
        className="px-4 py-8 md:px-6 lg:px-8 bg-no-repeat bg-right-bottom"
        id="features">
        <div
          className="text-4xl font-bold text-center md:text-center p-3"
          style={{
            color: "#013473",
            fontFamily: "Inter",
            marginBottom: "50px",
          }}>
          {language === "EN" ? messages.judulGoal : messages.judulGoalId}
        </div>
        <div className="surface">
          <div className="grid">
            {/* card 1 */}
            <div className="col-12 lg:col-3 p-3" >
              <div
                className="p-3  shadow-2 "
                style={{
                  minHeight: "315px",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor:'white',
                  borderRadius:'5px'
                }}>
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "12px",
                    backgroundColor: "#c6ede9",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  >
                  <i className="pi pi-check" style={{ color: "#119e9d", fontSize: "24px" }}></i>
                </div>
                <div className="mt-4">
                  <span className="text-900 text-xl font-medium">
                    <h4 style={{ fontFamily: "Inter", fontWeight:'bold' }}>
                      {language === "EN"
                        ? messages.anakJudulGoal1
                        : messages.anakJudulGoalId1}
                    </h4>
                  </span>
                  <p className="mt-4 mb-0 text-700 font-medium text-l">
                    {language === "EN"
                      ? messages.isiGoal1
                      : messages.isiGoalId1}
                  </p>
                </div>
              </div>
            </div>
            {/* card 2 */}
            <div className="col-12 lg:col-3 p-3">
              <div
                className="p-3 shadow-2"
                style={{
                  minHeight: "315px",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor:'white',
                  borderRadius:'5px'
                }}>
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "12px", // lebih membulat sesuai gambar
                    backgroundColor: "#ead6fd", // warna ungu muda
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
              >
                <i className="pi pi-users" style={{ color: "#9b4ede", fontSize: "24px" }}></i>
              </div>

                <div className="mt-4">
                  <span className="text-900 text-xl font-medium ">
                    <h4 style={{ fontFamily: "Inter", fontWeight:'bold' }}>
                      {language === "EN"
                        ? messages.anakJudulGoal2
                        : messages.anakJudulGoalId2}
                    </h4>
                  </span>
                  <p className="mt-4 mb-0 text-700 font-medium text-l">
                    {language === "EN"
                      ? messages.isiGoal2
                      : messages.isiGoalId2}
                  </p>
                </div>
              </div>
            </div>
            {/* card 3 */}
            <div className="col-12 lg:col-3 p-3">
              <div
                className="p-3  shadow-2"
                style={{
                  minHeight: "315px",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor:'white',
                  borderRadius:'5px'
                }}>
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "12px",
                    backgroundColor: "#feddc7",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <i className="pi pi-chart-bar" style={{ color: "#d16013", fontSize: "24px" }}></i>
                </div>
                <div className="mt-4">
                  <span className="text-900 text-xl font-medium ">
                    <h4 style={{ fontFamily: "Inter", fontWeight:'bold' }}>
                      {language === "EN"
                        ? messages.anakJudulGoal3
                        : messages.anakJudulGoalId3}
                    </h4>
                  </span>
                  <p className="mt-4 mb-0 text-700 font-medium text-l">
                    {language === "EN"
                      ? messages.isiGoal3
                      : messages.isiGoalId3}
                  </p>
                </div>
              </div>
            </div>
            {/* card 4 */}
            <div className="col-12 lg:col-3 p-3">
              <div
                className="p-3 shadow-2 "
                style={{
                  minHeight: "315px",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor:'white',
                  borderRadius:'5px'
                }}>
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "12px",
                    backgroundColor: "#c6ede9",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  >
                  <i className="pi pi-sort-amount-up-alt" style={{ color: "#119a8b", fontSize: "24px" }}></i>
                </div>
                <div className="mt-4">
                  <span className="text-900 text-xl font-medium ">
                    <h4 style={{ fontFamily: "Inter", fontWeight:'bold' }}>
                      {language === "EN"
                        ? messages.anakJudulGoal4
                        : messages.anakJudulGoalId4}
                    </h4>
                  </span>
                  <p className="mt-4 mb-0 text-700 font-medium text-l">
                    {language === "EN"
                      ? messages.isiGoal4
                      : messages.isiGoalId4}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Features;
